import React, { createContext, useContext, useState, useEffect } from 'react';

const DeviceSelectionContext = createContext();

export const DeviceSelectionProvider = ({ children }) => {
  const [selectedDeviceId, setSelectedDeviceIdState] = useState(() => {
    return localStorage.getItem('selectedDeviceId') || '';
  });

  useEffect(() => {
    if (selectedDeviceId) {
      localStorage.setItem('selectedDeviceId', selectedDeviceId);
    } else {
      localStorage.removeItem('selectedDeviceId');
    }
  }, [selectedDeviceId]);

  const setSelectedDeviceId = (id) => {
    setSelectedDeviceIdState(id);
  };

  return (
    <DeviceSelectionContext.Provider value={{ selectedDeviceId, setSelectedDeviceId }}>
      {children}
    </DeviceSelectionContext.Provider>
  );
};

export const useDeviceSelection = () => useContext(DeviceSelectionContext);
